import { render, staticRenderFns } from "./CustomerFeedback.vue?vue&type=template&id=2cbaa3c9&"
import script from "./CustomerFeedback.vue?vue&type=script&lang=js&"
export * from "./CustomerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports